'use strict';

var _ = require('lodash');
var PooledSeasonalityDataCacheService = function PooledSeasonalityDataCacheService($cacheFactory, $log) {
  var dataRetrievalCache = $cacheFactory('calendarReviewCache', {
    capacity: 25
  });
  var cachedUrls = [];
  function addUrlToList(url) {
    var index = cachedUrls.indexOf(url);
    if (index !== -1) {
      cachedUrls.splice(index, 1);
    }
    cachedUrls.push(url);
  }
  function putDataToCache(url, queryString, cacheData) {
    var cacheKey = url + queryString;
    addUrlToList(cacheKey);
    $log.debug('Adding URL ' + cacheKey + ' to Cache');
    dataRetrievalCache.put(url + queryString, {
      data: cacheData
    });
  }
  function invalidateCache() {
    $log.debug('Invalidating Pooled Seasonality Cache');
    _.forEach(cachedUrls, dataRetrievalCache.remove);
  }
  function getDataFromCache(url, queryString) {
    var cacheKey = url + queryString;
    var cachedData = dataRetrievalCache.get(cacheKey);
    $log.debug('Cached object retrieved for key ' + cacheKey + ' is ' + cachedData);
    return cachedData ? cachedData.data : undefined;
  }
  return {
    putData: putDataToCache,
    invalidate: invalidateCache,
    getData: getDataFromCache
  };
};
PooledSeasonalityDataCacheService.$inject = ['$cacheFactory', '$log'];
module.exports = PooledSeasonalityDataCacheService;